import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { TabNames, useWithdrawDataAtom } from '@capsicum/features/wallet/shared';

export const useWalletFanTokenNetworkGuard: Guard = () => {
	const { fanToken, selectedNetworkType } = useWithdrawDataAtom();

	const router = useRouter();

	const onDenied = () => router.push(`/wallet?tab=${TabNames.FAN_TOKENS}`);
	const status = !fanToken || !selectedNetworkType ? 'denied' : 'allowed';

	return {
		onDenied,
		status
	};
};
